import mapKeys from 'lodash.mapkeys';
import camelcase from 'lodash.camelcase';


export default function objectKeysToCamel (object) {
  return mapKeys(object, (value, key) => camelcase(key));
}
